export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12911.8a264152.jpg";